import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { styled } from 'styled-components';
import { Avatar } from '@design-system/avatar';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { Flag } from '@design-system/flag';
import { useI18n } from '@design-system/i18n';
import { Cover } from './Cover';
import { GroupAndContentType } from './GroupAndContentType';
import { LinkWrapper } from './LinkWrapper';
const DEFAULT_DISPLAY_FIELDS = {
    description: false,
    group: false,
    contentType: false,
    user: false,
};
export const FolderPresentation = ({ UserInformationWrapper = Fragment, contentTypeName, data: { description, folderLabel, group, image, name, user }, displayFields = DEFAULT_DISPLAY_FIELDS, onClick, path, withLink, }) => {
    const { __ } = useI18n();
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, width: "100%", children: [_jsx(ImageWrapper, { children: _jsx(Cover, { fallbackIconName: "folders", imageSrc: image, onClick: onClick, path: path, withLink: withLink, children: _jsx(FlagWrapper, { children: _jsx(Flag, { text: folderLabel !== null && folderLabel !== void 0 ? folderLabel : __('items') }) }) }) }), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: "100%", children: [((displayFields.group && group) || displayFields.contentType) && (_jsx(GroupAndContentType, { group: displayFields.group ? group : undefined, type: displayFields.contentType
                            ? contentTypeName !== null && contentTypeName !== void 0 ? contentTypeName : __('Folder')
                            : undefined })), _jsx(Box, { mb: 1, children: _jsx(LinkWrapper, { font: "h4-semibold", onClick: onClick, path: path, withLink: withLink, children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) }), displayFields.description && description && (_jsx(Box, { children: _jsx(TextWrapper, { width: "100%", children: _jsx(Dotdotdot, { clamp: 2, children: description }) }) })), displayFields.user && user && (_jsx(Box, { mt: 2, children: _jsx(UserInformationWrapper, { id: user.id, children: _jsxs(Box, { alignItems: "center", children: [_jsx(Avatar, { alt: "", href: withLink ? user.path : undefined, mr: 3, size: "32px", src: user.photo_thumb_url, tabIndex: -1 }), _jsx(Box, { alignItems: "center", justifyContent: "center", children: _jsx(LinkWrapper, { font: "body-semibold-asphalt", path: user.path, withLink: withLink, children: user.name }) })] }) }) }))] })] }));
};
const ImageWrapper = styled(Box).attrs({
    height: '118px',
    maxWidth: { _: '221px', m: '210px' },
    minHeight: '118px',
    minWidth: { _: '221px', m: '210px' },
    mr: 5,
    mb: { _: 4, m: 0 },
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
  position: relative;
`;
const TextWrapper = styled(Box) `
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
`;
const FlagWrapper = styled(Box).attrs({
    m: 2,
}) `
  position: absolute;
  top: 0;
`;
//# sourceMappingURL=FolderPresentation.js.map